import investmentRule from './investment_rules';

const INVESTMENT_GUIDANCE = {
  vi: {
    'Mộc': {
      summary: '👉 Ưu tiên đầu tư tăng trưởng dài hạn, tập trung vào giá trị bền vững.',
      fit: [
        'Ngành giáo dục, y tế, môi trường',
        'Doanh nghiệp tăng trưởng đều, văn hóa mạnh',
        'ETF/bluechip tăng trưởng dài hạn'
      ],
      avoid: [
        'Lướt sóng quá nhanh, thiếu nghiên cứu',
        'Danh mục quá phân tán',
        'Đòn bẩy cao khi chưa ổn định dòng tiền'
      ]
    },
    'Hỏa': {
      summary: '👉 Hợp chiến lược tăng trưởng mạnh nhưng cần kỷ luật chốt lời.',
      fit: [
        'Công nghệ, truyền thông, tiêu dùng nhanh',
        'Quỹ/ETF theo xu hướng tăng trưởng',
        'Đầu tư theo chu kỳ có kiểm soát'
      ],
      avoid: [
        'FOMO theo tin nóng',
        'Giao dịch đòn bẩy cao',
        'Bỏ qua quản trị rủi ro'
      ]
    },
    'Thổ': {
      summary: '👉 Ưu tiên tài sản ổn định và dòng tiền đều.',
      fit: [
        'Bất động sản có dòng tiền',
        'Trái phiếu/bluechip phòng thủ',
        'Dự án hạ tầng dài hạn'
      ],
      avoid: [
        'Đầu tư mạo hiểm quá sớm',
        'Sản phẩm thiếu dòng tiền',
        'Danh mục xoay vòng liên tục'
      ]
    },
    'Kim': {
      summary: '👉 Hợp chiến lược kỷ luật, thiên về quản trị rủi ro.',
      fit: [
        'Tài chính – ngân hàng – bảo hiểm',
        'Cổ phiếu cơ bản, định giá hợp lý',
        'Danh mục có quy tắc rebalancing'
      ],
      avoid: [
        'Đặt cược một mã duy nhất',
        'Đầu tư cảm tính',
        'Thiếu kế hoạch thoát lệnh'
      ]
    },
    'Thủy': {
      summary: '👉 Ưu tiên thanh khoản, linh hoạt và theo dõi dòng tiền.',
      fit: [
        'Cổ phiếu thanh khoản cao, dòng tiền mạnh',
        'Quỹ trái phiếu ngắn hạn, kênh linh hoạt',
        'Phân bổ theo chiến lược phòng thủ'
      ],
      avoid: [
        'Giữ tài sản kém thanh khoản quá lâu',
        'Đòn bẩy cao khi thị trường biến động',
        'Bỏ qua tín hiệu dòng tiền'
      ]
    }
  },
  en: {
    'Mộc': {
      summary: '👉 Favor long-term growth with sustainable value.',
      fit: [
        'Education, healthcare, sustainability sectors',
        'Steady-growth companies with strong culture',
        'Long-term growth ETFs/bluechips'
      ],
      avoid: [
        'Fast speculative trading without research',
        'Over-diversified portfolios',
        'High leverage before cashflow stability'
      ]
    },
    'Hỏa': {
      summary: '👉 Suits aggressive growth with disciplined exits.',
      fit: [
        'Tech, media, fast-moving consumer',
        'Growth-oriented ETFs',
        'Cycle-based investing with controls'
      ],
      avoid: [
        'FOMO trades',
        'High leverage',
        'Ignoring risk management'
      ]
    },
    'Thổ': {
      summary: '👉 Favor stable assets and recurring cashflow.',
      fit: [
        'Cashflow real estate',
        'Defensive bonds/bluechips',
        'Long-term infrastructure projects'
      ],
      avoid: [
        'Overly risky early-stage bets',
        'Assets without cashflow',
        'Constant portfolio churn'
      ]
    },
    'Kim': {
      summary: '👉 Best with disciplined, risk-controlled strategies.',
      fit: [
        'Finance, banking, insurance',
        'Fundamental/value equities',
        'Rule-based rebalancing portfolios'
      ],
      avoid: [
        'Single-name bets',
        'Emotional investing',
        'No exit plan'
      ]
    },
    'Thủy': {
      summary: '👉 Prioritize liquidity and adaptive allocation.',
      fit: [
        'High-liquidity equities with strong flows',
        'Short-term bond funds',
        'Defensive allocation strategies'
      ],
      avoid: [
        'Illiquid holdings kept too long',
        'High leverage in volatile markets',
        'Ignoring cashflow signals'
      ]
    }
  }
};

const FAMILY_GUIDANCE = {
  vi: {
    'Mộc': 'Cần cảm giác được lắng nghe; ưu tiên giao tiếp nhẹ nhàng và không gian riêng.',
    'Hỏa': 'Dễ bộc lộ cảm xúc; nên học cách hạ nhiệt khi căng thẳng.',
    'Thổ': 'Ưu tiên ổn định; cần chia sẻ trách nhiệm để tránh ôm đồm.',
    'Kim': 'Thẳng thắn, lý trí; nên mềm hóa cách diễn đạt để tránh khô khan.',
    'Thủy': 'Nhạy cảm và sâu; cần chia sẻ đều đặn để tránh tự áp lực.'
  },
  en: {
    'Mộc': 'Needs to feel heard; prioritize gentle communication and personal space.',
    'Hỏa': 'Expressive emotions; practice cooling down during tension.',
    'Thổ': 'Values stability; share responsibilities to avoid overburdening.',
    'Kim': 'Direct and logical; soften delivery to avoid being too rigid.',
    'Thủy': 'Sensitive and deep; share regularly to reduce self-pressure.'
  }
};

// =====================================================
// TEN GODS (Thập Thần) → Investment Overlay (VI/EN)
// Deterministic merge with INVESTMENT_GUIDANCE
// =====================================================

const TEN_GODS = [
  'Tỷ Kiên',
  'Kiếp Tài',
  'Thực Thần',
  'Thương Quan',
  'Chính Tài',
  'Thiên Tài',
  'Chính Quan',
  'Thiên Quan',
  'Chính Ấn',
  'Thiên Ấn'
];

const TEN_GODS_INVESTMENT_GUIDANCE = {
  vi: {
    'Chính Tài': {
      summary: '👉 Thiên về kỷ luật tài chính, ưu tiên bền vững và dòng tiền rõ ràng.',
      fit: [
        'Danh mục core ổn định (bluechip/ETF), tích lũy định kỳ',
        'Tập trung doanh nghiệp có dòng tiền/biên lợi nhuận bền',
        'Chiến lược phân bổ tỷ trọng rõ ràng'
      ],
      avoid: [
        'Lướt sóng cảm tính, thay đổi danh mục liên tục',
        'Đặt cược ‘một kèo’ không có kế hoạch',
        'Đòn bẩy khi chưa kiểm soát rủi ro'
      ],
      discipline: [
        'Quy tắc ngân sách đầu tư cố định theo tháng',
        'Review theo quý dựa trên dữ kiện',
        'Ưu tiên quản trị rủi ro hơn tối đa lợi nhuận'
      ]
    },
    'Thiên Tài': {
      summary: '👉 Hợp cơ hội theo chu kỳ/tín hiệu, nhưng cần giới hạn rủi ro rất rõ.',
      fit: [
        'Vệ tinh (satellite) theo cơ hội: ngành chu kỳ, sự kiện, dòng tiền',
        'Chốt lời từng phần khi đạt mục tiêu',
        'Kỷ luật điểm vào/ra trước khi giải ngân'
      ],
      avoid: [
        'FOMO theo tin nóng',
        'All-in vào cơ hội ‘nghe hấp dẫn’',
        'Giữ vị thế rủi ro quá lâu khi thesis đã đổi'
      ],
      discipline: [
        'Giới hạn tỷ trọng vệ tinh (ví dụ 10–30% tùy khẩu vị)',
        'Luôn có mức cắt giảm tỷ trọng khi sai kịch bản',
        'Ghi log giao dịch để tránh ‘đánh theo cảm xúc’'
      ]
    },
    'Chính Quan': {
      summary: '👉 Ưa nguyên tắc, hợp đầu tư theo hệ thống/quy trình và tuân thủ kỷ luật.',
      fit: [
        'Danh mục có quy tắc (DCA + rebalancing)',
        'Cổ phiếu cơ bản/định giá hợp lý, tiêu chí rõ',
        'Kênh minh bạch, sản phẩm dễ hiểu'
      ],
      avoid: [
        'Chiến lược thiếu quy trình',
        'Mua vì lời rỉ tai/đồn đoán',
        'Phá kỷ luật vì biến động ngắn hạn'
      ],
      discipline: [
        'Checklist trước khi mua (định giá, nợ, dòng tiền…)',
        'Đặt ngưỡng rủi ro danh mục và tuân thủ',
        'Tái cân bằng theo ngưỡng lệch phân bổ'
      ]
    },
    'Thiên Quan': {
      summary: '👉 Chịu rủi ro tốt hơn, hợp chiến lược chủ động nhưng phải có ‘lan can’ an toàn.',
      fit: [
        'Chiến lược theo xu hướng/chu kỳ có kiểm soát',
        'Thiết kế kịch bản xấu và phương án phòng thủ',
        'Ưu tiên sản phẩm thanh khoản, dễ thoát vị thế'
      ],
      avoid: [
        'Mạo hiểm liên tục không có giới hạn',
        'Tăng đòn bẩy khi thị trường biến động',
        'Giữ lệnh ‘hy vọng’ khi kịch bản xấu đã xảy ra'
      ],
      discipline: [
        'Đặt giới hạn lỗ/tổn thất tối đa cho danh mục',
        'Giảm rủi ro khi biến động tăng (risk-off rõ ràng)',
        'Không ‘trả thù thị trường’ sau chuỗi thua'
      ]
    },
    'Chính Ấn': {
      summary: '👉 Mạnh về nghiên cứu – học hỏi; hợp đầu tư dựa trên hiểu biết và quy trình phân tích.',
      fit: [
        'Đầu tư theo thesis, ưu tiên hiểu doanh nghiệp',
        'Danh mục chất lượng, theo dõi KPI cốt lõi',
        'Tích lũy dài hạn theo dữ liệu'
      ],
      avoid: [
        'Mua theo cảm xúc/tin nóng',
        'Nhảy mã liên tục',
        'Bỏ qua chất lượng báo cáo/tài chính'
      ],
      discipline: [
        'Viết thesis 1 trang trước khi mua',
        'Theo dõi chỉ số cốt lõi theo quý',
        'Giữ nhật ký quyết định (vì sao mua/bán)'
      ]
    },
    'Thiên Ấn': {
      summary: '👉 Hợp ý tưởng mới/đa chiến lược, nhưng cần kiểm chứng bằng dữ kiện để tránh ‘ảo tưởng’.',
      fit: [
        'Khám phá chiến lược mới (nhưng thử bằng vốn nhỏ)',
        'Đa dạng hóa phương pháp (core ổn định + satellite thử nghiệm)',
        'Ưu tiên kênh minh bạch, dữ liệu rõ'
      ],
      avoid: [
        'Tin quá nhanh vào ‘kèo hay’ thiếu kiểm chứng',
        'Gom nhiều chiến lược gây rối kỷ luật',
        'Đánh cược dựa trên trực giác đơn thuần'
      ],
      discipline: [
        'A/B test chiến lược bằng quy mô nhỏ trước',
        'Chuẩn hóa tiêu chí vào/ra',
        'Định kỳ loại bỏ chiến lược không hiệu quả'
      ]
    },
    'Thực Thần': {
      summary: '👉 Ưa tích lũy và ‘ăn chắc mặc bền’; hợp chiến lược dài hạn, đều đặn.',
      fit: [
        'DCA/đầu tư định kỳ, tích sản theo thời gian',
        'Doanh nghiệp ổn định, tăng trưởng đều',
        'Danh mục ít xoay vòng, phí thấp'
      ],
      avoid: [
        'Giao dịch quá dày',
        'Chạy theo biến động ngắn hạn',
        'Đặt mục tiêu lợi nhuận phi thực tế'
      ],
      discipline: [
        'Giữ nhịp đầu tư cố định (tháng/quý)',
        'Tối ưu phí và kỷ luật phân bổ',
        'Kiên trì theo kế hoạch trừ khi thesis sai'
      ]
    },
    'Thương Quan': {
      summary: '👉 Mạnh về góc nhìn phản biện; hợp chiến lược chủ động nhưng dễ ‘nói/đánh quá tay’ nếu thiếu kỷ luật.',
      fit: [
        'Phân tích phản biện, tìm định giá lệch (nếu có dữ kiện)',
        'Chiến lược theo hệ thống (rule-based) để tránh cảm xúc',
        'Chốt lời/cắt lỗ theo kế hoạch'
      ],
      avoid: [
        'Giao dịch để ‘chứng minh mình đúng’',
        'Đuổi theo thị trường khi nóng',
        'Tăng tần suất vì hưng phấn'
      ],
      discipline: [
        'Time-box quyết định, tránh overtrade',
        'Luôn có quy tắc thoát lệnh',
        'Ưu tiên xác suất & quản trị rủi ro'
      ]
    },
    'Tỷ Kiên': {
      summary: '👉 Tự chủ, thích tự quyết; hợp chiến lược tập trung có chọn lọc nhưng cần tránh ‘cố chấp’ với một mã.',
      fit: [
        'Danh mục tập trung vừa phải (có tiêu chí rõ)',
        'Theo thesis, bám nguyên tắc quản trị rủi ro',
        'Ưu tiên doanh nghiệp chất lượng'
      ],
      avoid: [
        'All-in một mã duy nhất',
        'Không chịu cập nhật dữ kiện xấu',
        'Bỏ qua phân bổ tài sản tổng thể'
      ],
      discipline: [
        'Giới hạn tỷ trọng 1 mã/1 ngành',
        'Có điều kiện ‘thesis sai’ để giảm tỷ trọng',
        'Tái cân bằng theo ngưỡng'
      ]
    },
    'Kiếp Tài': {
      summary: '👉 Dễ thiên về cạnh tranh/rủi ro; hợp chiến lược linh hoạt nhưng phải khóa kỷ luật để tránh ‘quá tay’.',
      fit: [
        'Chiến lược chủ động với giới hạn rủi ro chặt',
        'Tập trung vào quản trị vị thế (position sizing)',
        'Ưu tiên thanh khoản cao'
      ],
      avoid: [
        'Đòn bẩy cao',
        'Gồng lỗ để ‘gỡ’',
        'Đánh theo cảm xúc/ăn thua'
      ],
      discipline: [
        'Đặt mức lỗ tối đa/ngày và/ngày giao dịch',
        'Không tăng rủi ro sau chuỗi thua',
        'Kỷ luật dừng nghỉ khi tâm lý không ổn'
      ]
    }
  },
  en: {
    'Chính Tài': {
      summary: '👉 Discipline-first, prefers sustainable value and clear cashflows.',
      fit: [
        'Stable core (bluechips/ETFs) with periodic accumulation',
        'Cashflow/quality-driven businesses',
        'Clear allocation rules'
      ],
      avoid: [
        'Emotion-driven frequent churn',
        'Single big bet without a plan',
        'Leverage without risk control'
      ],
      discipline: [
        'Fixed monthly investing budget',
        'Quarterly evidence-based reviews',
        'Risk management over maximizing returns'
      ]
    },
    'Thiên Tài': {
      summary: '👉 Opportunity/cycle-friendly, but needs strict risk caps.',
      fit: [
        'Satellite opportunities (cycles/events/flows)',
        'Scale out profits as targets hit',
        'Pre-defined entry/exit rules'
      ],
      avoid: [
        'FOMO trades',
        'All-in on ‘exciting’ ideas',
        'Holding risk positions after thesis changes'
      ],
      discipline: [
        'Cap satellite weight (e.g., 10–30% by risk tolerance)',
        'Reduce when scenario breaks',
        'Trade journaling to avoid emotions'
      ]
    },
    'Chính Quan': {
      summary: '👉 Rule-oriented; best with systems and process discipline.',
      fit: [
        'Rules-based portfolios (DCA + rebalancing)',
        'Fundamental/value with clear criteria',
        'Transparent, easy-to-understand instruments'
      ],
      avoid: [
        'No-process strategies',
        'Rumor-based buying',
        'Breaking rules due to short-term volatility'
      ],
      discipline: [
        'Pre-buy checklist (valuation, debt, cashflow...)',
        'Portfolio risk guardrails',
        'Rebalance by allocation drift thresholds'
      ]
    },
    'Thiên Quan': {
      summary: '👉 Higher risk tolerance; needs strong guardrails and downside planning.',
      fit: [
        'Controlled trend/cycle strategies',
        'Downside scenarios + defense plan',
        'High-liquidity instruments'
      ],
      avoid: [
        'Unlimited risk-taking',
        'Leverage in volatile regimes',
        'Hope-holding after the downside hits'
      ],
      discipline: [
        'Max loss / max drawdown limits',
        'Risk-off rules when volatility rises',
        'No revenge trading'
      ]
    },
    'Chính Ấn': {
      summary: '👉 Research-driven; invests from understanding and analysis.',
      fit: [
        'Thesis-based investing, business understanding',
        'Quality portfolios with KPI tracking',
        'Data-driven long-term accumulation'
      ],
      avoid: [
        'News-chasing',
        'Constant name-hopping',
        'Ignoring financial/reporting quality'
      ],
      discipline: [
        'Write a 1-page thesis before buying',
        'Quarterly KPI reviews',
        'Decision journal (why buy/sell)'
      ]
    },
    'Thiên Ấn': {
      summary: '👉 Creative/multi-strategy; must validate with evidence to avoid illusions.',
      fit: [
        'Explore new methods with small sizing',
        'Core stability + experimental satellite',
        'Transparent data and instruments'
      ],
      avoid: [
        'Believing ‘great ideas’ too fast',
        'Too many strategies that break discipline',
        'Pure intuition bets'
      ],
      discipline: [
        'Small-scale A/B testing first',
        'Standardized entry/exit criteria',
        'Remove non-performing strategies periodically'
      ]
    },
    'Thực Thần': {
      summary: '👉 Patient accumulator; best with steady long-term compounding.',
      fit: [
        'DCA / periodic investing',
        'Steady-growth businesses',
        'Low-churn, low-fee portfolios'
      ],
      avoid: [
        'Over-trading',
        'Chasing short-term moves',
        'Unrealistic return targets'
      ],
      discipline: [
        'Fixed cadence (monthly/quarterly)',
        'Optimize fees and allocation discipline',
        'Stay the course unless thesis breaks'
      ]
    },
    'Thương Quan': {
      summary: '👉 Strong contrarian thinking; needs rules to avoid over-aggression.',
      fit: [
        'Evidence-based contrarian/value opportunities',
        'Rule-based systems to reduce emotions',
        'Planned profit-taking/stop rules'
      ],
      avoid: [
        'Trading to ‘prove right’',
        'Chasing hot markets',
        'Over-trading from excitement'
      ],
      discipline: [
        'Time-box decisions',
        'Always define exits',
        'Probability & risk management first'
      ]
    },
    'Tỷ Kiên': {
      summary: '👉 Independent decision-maker; fits selective focus but avoid stubborn single-name risk.',
      fit: [
        'Moderate focus with clear criteria',
        'Thesis + risk discipline',
        'Quality-first selection'
      ],
      avoid: [
        'All-in single name',
        'Not updating on bad evidence',
        'Ignoring total asset allocation'
      ],
      discipline: [
        'Cap position/sector weights',
        'Define ‘thesis broken’ conditions',
        'Rebalance by thresholds'
      ]
    },
    'Kiếp Tài': {
      summary: '👉 Competitive/high-risk tendency; must lock strict discipline to avoid overreach.',
      fit: [
        'Active strategies with tight risk caps',
        'Position sizing focus',
        'High-liquidity focus'
      ],
      avoid: [
        'High leverage',
        'Averaging down to ‘recover’',
        'Emotion-driven bets'
      ],
      discipline: [
        'Max loss per day/week rules',
        'Don’t increase risk after a losing streak',
        'Cooldown when psychology is unstable'
      ]
    }
  }
};

const uniqueStrings = (items) => Array.from(new Set((items || []).filter(Boolean)));

const walkStrings = (value, out = []) => {
  if (!value) {
    return out;
  }
  if (typeof value === 'string') {
    out.push(value);
  } else if (Array.isArray(value)) {
    value.forEach((item) => walkStrings(item, out));
  } else if (typeof value === 'object') {
    Object.values(value).forEach((item) => walkStrings(item, out));
  }
  return out;
};

const extractTenGodCounts = (ctx) => {
  const raw = ctx?.thapThan
    || ctx?.thap_than
    || ctx?.chart?.thapThan
    || ctx?.result?.thapThan;
  const bag = walkStrings(raw, []).join(' | ');
  const counts = Object.fromEntries(TEN_GODS.map((key) => [key, 0]));

  TEN_GODS.forEach((key) => {
    const matches = bag.split(key).length - 1;
    counts[key] = Math.max(0, matches);
  });

  return counts;
};

const getTopTenGods = (ctx, topN = 2) => {
  const counts = extractTenGodCounts(ctx);
  const order = TEN_GODS;

  return Object.entries(counts)
    .sort((a, b) => (b[1] - a[1]) || (order.indexOf(a[0]) - order.indexOf(b[0])))
    .filter(([, count]) => count > 0)
    .slice(0, topN)
    .map(([key]) => key);
};

const getDominantElement = (ctx) => {
  const nguHanh = ctx?.nguHanh
    || ctx?.ngu_hanh
    || ctx?.chart?.nguHanh
    || ctx?.result?.nguHanh
    || {};
  const counts = nguHanh?.counts || nguHanh?.dem || nguHanh?.count || {};
  const values = {
    'Mộc': counts['Mộc'] ?? counts['Moc'] ?? 0,
    'Hỏa': counts['Hỏa'] ?? counts['Hoa'] ?? 0,
    'Thổ': counts['Thổ'] ?? counts['Tho'] ?? 0,
    'Kim': counts['Kim'] ?? 0,
    'Thủy': counts['Thủy'] ?? counts['Thuy'] ?? 0
  };
  const order = ['Mộc', 'Hỏa', 'Thổ', 'Kim', 'Thủy'];
  const total = Object.values(values).reduce((sum, value) => sum + value, 0);
  if (!total) return null;

  return order
    .map((key) => [key, values[key]])
    .sort((a, b) => (b[1] - a[1]) || (order.indexOf(a[0]) - order.indexOf(b[0])))[0][0];
};

const getTenGodCountsFromCtx = (ctx) => (
  ctx?.ten_god_counts
  || ctx?.tenGodCounts
  || ctx?.chart?.ten_god_counts
  || ctx?.chart?.tenGodCounts
  || {}
);

const getNguHanhCountsFromCtx = (ctx) => (
  ctx?.ngu_hanh?.counts
  || ctx?.nguHanh?.counts
  || ctx?.five_elements
  || ctx?.fiveElements
  || {}
);

const getNguHanhPercentsFromCtx = (ctx) => (
  ctx?.ngu_hanh?.ratios
  || ctx?.nguHanh?.ratios
  || null
);

const getRelationsSummaryFromCtx = (ctx) => {
  const quanHe = ctx?.quan_he || ctx?.quanHe || {};
  if (quanHe?.xung || quanHe?.hinh || quanHe?.hai) {
    return {
      xung: Array.isArray(quanHe?.xung) ? quanHe.xung.length : 0,
      hinh: Array.isArray(quanHe?.hinh) ? quanHe.hinh.length : 0,
      hai: Array.isArray(quanHe?.hai) ? quanHe.hai.length : 0
    };
  }
  return ctx?.relationsSummary || null;
};

const buildInvestmentGuidanceCombined = (ctx, lang = 'vi') => {
  const element = getDominantElement(ctx);
  const tenGods = getTopTenGods(ctx, 2);
  const base = INVESTMENT_GUIDANCE?.[lang]?.[element] || {
    summary: '',
    fit: [],
    avoid: []
  };

  const overlays = tenGods
    .map((tenGod) => TEN_GODS_INVESTMENT_GUIDANCE?.[lang]?.[tenGod])
    .filter(Boolean);

  const summaryParts = [
    base.summary,
    ...overlays.map((overlay) => overlay.summary)
  ].filter(Boolean);

  const fit = uniqueStrings([
    ...(base.fit || []),
    ...overlays.flatMap((overlay) => overlay.fit || [])
  ]);

  const avoid = uniqueStrings([
    ...(base.avoid || []),
    ...overlays.flatMap((overlay) => overlay.avoid || [])
  ]);

  const discipline = uniqueStrings(overlays.flatMap((overlay) => overlay.discipline || []));

  return {
    element,
    tenGods,
    summary: summaryParts.join('\n'),
    fit,
    avoid,
    discipline
  };
};

const buildInvestmentGuidanceProfile = (ctx, lang = 'vi') => {
  const combined = buildInvestmentGuidanceCombined(ctx, lang);
  const tenGodCounts = getTenGodCountsFromCtx(ctx);
  const elementCounts = getNguHanhCountsFromCtx(ctx);
  const elementPercents = getNguHanhPercentsFromCtx(ctx);
  const relationsSummary = getRelationsSummaryFromCtx(ctx);
  const hasTenGodCounts = Object.values(tenGodCounts || {}).some((value) => Number(value) > 0);
  const hasElementCounts = Object.values(elementCounts || {}).some((value) => Number(value) > 0);
  const hasElementPercents = Object.values(elementPercents || {}).some((value) => Number(value) > 0);

  if (!hasTenGodCounts && !hasElementCounts && !hasElementPercents) {
    return null;
  }
  const profile = investmentRule({
    tenGodCounts,
    elementCounts,
    elementPercents,
    relationsSummary
  });

  return {
    ...combined,
    profile
  };
};

export {
  FAMILY_GUIDANCE,
  INVESTMENT_GUIDANCE,
  TEN_GODS_INVESTMENT_GUIDANCE,
  buildInvestmentGuidanceCombined,
  buildInvestmentGuidanceProfile
};
